var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUploadDoc(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 23,
    viewBox: "0 0 19 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.3499 7.60004H18.5629C18.2312 6.72117 17.716 5.92317 17.0515 5.25925L13.7417 1.94754C13.077 1.28381 12.2787 0.76889 11.3999 0.437042V6.65005C11.3999 7.17467 11.8252 7.60004 12.3499 7.60004Z",
    fill: "#3054EA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.9772 9.5H12.35C10.776 9.5 9.5 8.224 9.5 6.65V0.0228C9.34704 0.0123352 9.19411 0 9.03923 0H4.74998C2.12793 0.00316172 0.00311719 2.12797 0 4.75002V18.0501C0.00311719 20.6721 2.12793 22.7969 4.74998 22.8H14.25C16.872 22.7969 18.9968 20.6721 19 18.05V9.96076C19 9.80593 18.9877 9.65296 18.9772 9.5Z",
    fill: "#3054EA"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUploadDoc);
export default __webpack_public_path__ + "static/media/upload-doc.2a9cf2178eda7052952e885d37698bf7.svg";
export { ForwardRef as ReactComponent };